<mat-drawer-container class="ft-app-container">
  <mat-drawer mode="side" opened="true">
     <ft-drawer-links [links]="links"></ft-drawer-links>
  </mat-drawer>
  <mat-drawer-content fxLayout="column">
        <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
